import type { Filter } from "@shopify/hydrogen-react/storefront-api-types";

/**
 * @description Collection에서 총 상품 갯수 가져오기
 */
export const getTotalProductCount = (filters: Filter[]) => {
  if (!filters.length) return 0;

  const count = filters.find((filter) => filter.id.includes("hidden"));
  if (!count) return 0;

  return (
    count.values.filter(
      ({ label }) => label === "아니요" || label === "No" || label === "いいえ",
    )[0]?.count || 0
  );
};
